export default __webpack_public_path__ + "static/media/logo-ach.15870596.png";